import React from "react";
import { useNav } from "../customHooks/useNav";
import "./Page.css";
import piercingmania from "../img/piercingmania.webp";
import bencomgroup from "../img/bencom.webp";
import tno from "../img/tno.webp";
import Item from "../components/Item";

const itemsList = [
  {
    index: 0,
    photo: tno,
    header: {
      where: "TNO",
      from: 2022,
      to: "nu",
      title: "Scientist",
      employmentType: "fulltime",
    },
    content: (
      <p>
        Scientist op de afdeling Data Ecosystemen binnen TNO.
        Gespecialiseerd in de technische kant van datadeelinfrastructuur. Ik hou me bezig met onder andere het creëren en implementeren van datadeelinfrastructuren.
      </p>
    ),
  },
  {
    index: 1,
    photo: bencomgroup,
    header: {
      where: "Bencom Group",
      from: 2020,
      to: 2022,
      title: "Backend Developer",
      employmentType: "fulltime",
    },
    content: (
      <>
        <p>
          Voornamelijk werkzaam voor de backend van de Bencompare app. Zowel
          het toevoegen van nieuwe functionaliteiten als werkzaamheden om de
          app optimaal te laten runnen. Gebruikte technieken:
        </p>
        <div className="job-tags">
          <span className="tag">Microsoft Azure</span>
          <span className="tag">GraphQL</span>
          <span className="tag">Django</span>
          <span className="tag">PostgreSQL</span>
          <span className="tag">Celery</span>
          <span className="tag">Docker</span>
        </div>
      </>
    ),
  },
  {
    index: 2,
    photo: piercingmania,
    header: {
      where: "Piercing Mania",
      from: 2018,
      to: 2020,
      title: "Backend Developer",
      employmentType: "parttime",
    },
    content: (
      <>
        <p>
          Een dashboard gebouwd met Django waarin sales data en voorraden per
          product en per categorie te zien waren.
        </p>
        <p>
          Gewerkt aan een manier om automatisch producten toe te kunnen
          voegen aan onze website. Hiervoor hebben we AirFlow, Celery en
          Django gecombineerd. Eerst werd data opgehaald met een zelf
          geschreven scraper, later kregen we een API koppeling.
        </p>
        <p>
          Gewerkt aan een applicatie in het framework Odoo, een open-source
          ERP pakket, om de bestaande applicatie te koppelen aan de werkwijze
          van het bedrijf. Daarnaast meegedacht over IT oplossingen op
          managementniveau.
        </p>
      </>
    ),
  },
];

const Jobs = () => {
  const jobsRef = useNav("Werkervaring");

  return (
    <section ref={jobsRef} id="jobsContainer">
      <div className="section-inner jobs-inner">
        <div className="jobs-heading-wrap">
          <div className="numbered-label">03</div>
          <h2 className="jobs-heading">Mijn werkervaring</h2>
        </div>
        <div className="jobs-list">
          {itemsList.map((item) => (
            <Item
              key={item.index}
              header={item.header}
              photo={item.photo}
              content={item.content}
              defaultOpen={item.index === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Jobs;
